export class BaseActivationData {
    activationCode: string;
}